module.exports = {"Home":{"name":"首页","systemCode":2,"pageUrl":"http://www.parkdata.cn"},"Cydt":{"name":"大湾区产业地图","systemCode":3,"pageUrl":"http://map.parkdata.cn"},"Yqk":{"name":"大湾区园区库","systemCode":4,"pageUrl":"http://base.parkdata.cn"},"Dp":{"name":"园区大屏","systemCode":1,"pageUrl":"http://monitor.parkdata.cn"},"imgUpload":"http://8.129.78.28:8001/"}


//////////////////
// WEBPACK FOOTER
// ./src/common/config.json
// module id = CSED
// module chunks = 1